import { render, staticRenderFns } from "./text-money.mpx?vue&type=template&id=6fffc4f3&scoped=true&component=true&componentId=text-money35e493b0"
import script from "./text-money.mpx?vue&type=script&lang=js&component=true&componentId=text-money35e493b0"
export * from "./text-money.mpx?vue&type=script&lang=js&component=true&componentId=text-money35e493b0"
import style0 from "./text-money.mpx?vue&type=style&index=0&id=6fffc4f3&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m35e493b0%22%7D&component=true&componentId=text-money35e493b0"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fffc4f3",
  null
  
)

export default component.exports